import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';


import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { AngularFireFunctionsModule } from '@angular/fire/compat/functions';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireModule } from '@angular/fire/compat';
import { FormsModule } from '@angular/forms';
import { withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app/app-routing.module';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { ApiCallsService } from './app/services/api-calls.service';
import { ArticlesService } from './app/services/articles.service';
import { SharedModule } from './app/shared/shared.module';
import { QuillModule } from 'ngx-quill';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),importProvidersFrom(
            BrowserModule,
            AppRoutingModule,
            SharedModule,
            RouterModule,
            FormsModule,
            AngularFireModule.initializeApp(environment.firebaseConfig),
            AngularFirestoreModule,
            AngularFireAuthModule,
            AngularFireDatabaseModule,
            AngularFireFunctionsModule,
            AngularFireStorageModule,
            QuillModule.forRoot()
        ),
        SharedModule,
        ArticlesService,
        ApiCallsService,
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi())
    ]
})
  .catch(err => console.error(err));
